module.exports = __webpack_public_path__ + "media/images/apple_icon-4db462830aa05d5d3682b34d0bfafb3d.svg";